module.exports = __webpack_public_path__ + "7e30076d.svg";